import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () => ({ breakpoints }: Theme) =>
  createStyles({
    containerCard: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      width: '100%',
      [breakpoints.up('lg')]: {
        textWrap: 'nowrap',
      },
    },
    graphTitle: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '20px 0px 16px',
    },
    modalGraph: { width: 900, justifyContent: 'center' },
    modalGraphTitle: {
      fontSize: 14,
    },
    details: {
      justifyContent: 'center',
      margin: '20px 0px',
      alignItems: 'end',
    },
    filterSelector: { marginRight: 25 },
    containerGraph: {
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      [breakpoints.down('md')]: {
        marginLeft: 0,
        justifyContent: 'flex-start',
      },
      [breakpoints.down(775)]: {
        justifyContent: 'center',
      },
      [breakpoints.down(575)]: {
        justifyContent: 'flex-start',
      },
    },
    legend: { justifyContent: 'center', margin: '20px 0px', alignItems: 'end' },
    filtersContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4px',
      marginLeft: 20,
      height: '100%',
      flex: 1,
    },
  });

export const overrideModalGraph = {
  content: {
    padding: '16px 20px',
    maxHeight: 470,
    overflowX: 'auto',
    width: 900,
  },
};

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};

export const overrideCardGraph = (breakpoints): any => ({
  alignItems: 'center',
  display: 'flex',
  [breakpoints.down('md')]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  [breakpoints.down(775)]: {
    flexFlow: 'unset',
    alignItems: 'center',
  },
  [breakpoints.down(575)]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  minHeight: 130,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});
